export default __webpack_public_path__ + "static/stock-market-forex-trading-graph-graphic-concept-83734ea1d1171eee06eede16154a2ad5.jpg";